import { DocusealBuilder, DocusealForm } from '@docuseal/react';
const DOCUSEAL_BUILDER_ELEMENT = 'docuseal-builder';
export const makeDocusealSlot = ()=>({
        Builder: DocusealBuilder,
        Form: DocusealForm,
        saveBuilder: async (container)=>{
            const builderElement = container.querySelector(DOCUSEAL_BUILDER_ELEMENT);
            if (!(builderElement === null || builderElement === void 0 ? void 0 : builderElement.save)) {
                throw new Error("Cannot save: no ".concat(DOCUSEAL_BUILDER_ELEMENT, " element with a save method was mounted"));
            }
            await builderElement.save();
        }
    });
